import { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Toast from 'react-bootstrap/Toast';
import Alert from "react-bootstrap/Alert";
import { resetPassword } from "./firebase";
import { Formik, FormikErrors } from "formik";

function ResetPassword() {
  const [alert, setAlert] = useState({alertType: "", msg: ""});
  const [showAlert, toggleShowAlert] = useState(false);
  const reset = function(email: string) {
    resetPassword(email).then(() => {
      setAlert({alertType: "success", msg: "Le hemos mandado un email"});
      toggleShowAlert(true);  
    });
  };
  interface FormValues {
    email: string,
  }
  return (
    <div className="m-5">
      <Row className="justify-content-md-center">
        <Col>
          <Toast show={showAlert} onClose={() => toggleShowAlert(false)}>
          <Toast.Header>
              <strong className="mr-auto">Alert</strong>
            </Toast.Header>
            <Toast.Body>
              {alert.alertType === "error" &&
                <Alert variant="danger">
                  {alert.msg}
                </Alert>
              }
              {alert.alertType === "success" &&
                <Alert variant="success">
                  {alert.msg}
                </Alert>
              }

            </Toast.Body>
          </Toast>
        </Col>
      </Row>
      <Formik
        initialValues={
          {
            email: "",
          }
        }
        onSubmit={async (values, actions) => {
          actions.setSubmitting(true);
          reset(values.email);
        }}
        validate={(values: FormValues) => {
          let errors: FormikErrors<FormValues> = {};
          if(!values.email) {
            errors.email = "Obligatorio"
          }
          return errors;
        }}
      >
        {({errors, touched, values, handleSubmit, handleChange}) => (
          <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Label>Correo electronico</Form.Label>
                  <Form.Control type="text" name="email" value={values.email} placeholder="Correo electronico" onChange={handleChange} />
                  {errors.email && touched.email && <Alert variant="danger">{errors.email}</Alert>}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Button variant="primary" type="submit">
                    Enviar
                  </Button>
                </Col>
              </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ResetPassword;